import {useQuery} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {environment} from '../../../../environments/environment';
import {customerQueryKeys} from '../customer-query-keys';
import {EnvisiaObjects} from '../../../common/wrapper.models';
import {CustomerComment} from './customer-comment.models';

export function useCustomerCommentsQuery(
  customerId: number,
) {
  const {data, isPending} = useQuery({
    queryKey: customerQueryKeys.comments(customerId),
    queryFn: () =>
      AxiosHttpClient.get<EnvisiaObjects<CustomerComment>>(`${environment.apiv4uri}customer/${customerId}/comments`),
    throwOnError: true,
  });

  return {
    comments: data?.objects ?? [],
    commentIsPending: isPending,
  };
}
